/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気契約情報
 */
export interface Szma103aResponseElecCtrSearchResultDtoElecCtrMstInfo {
    /**
     * 送配電事業者コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C020960」のユーザコードを設定
     */
    transBusCode?: string;
    /**
     * 送配電事業者コード名称：全半角混在
     */
    transBusCodeAname?: string;
    /**
     * 電圧区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C020970」のユーザコードを設定
     */
    voltDiv?: string;
    /**
     * 電圧区分名称：全半角混在
     */
    voltDivAname?: string;
    /**
     * 供給電圧区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C021070」のユーザコードを設定
     */
    supplyVoltDiv?: string;
    /**
     * 供給電圧区分名称：全半角混在
     */
    supplyVoltDivAname?: string;
    /**
     * 基本検針日：日付(yyyyMMdd)
     */
    basicKsdate?: string;
    /**
     * 請求月度区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C021080」のユーザコードを設定
     */
    claimMnttmDiv?: string;
    /**
     * 請求月度区分名称：全半角混在
     */
    claimMnttmDivAname?: string;
    /**
     * 検針区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C403320」のユーザコードを設定
     */
    kensinDiv?: string;
    /**
     * 検針区分名称：全半角混在
     */
    kensinDivAname?: string;
    /**
     * 検針日区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C403330」のユーザコードを設定
     */
    kensindateDiv?: string;
    /**
     * 検針日区分名称：全半角混在
     */
    kensindateDivAname?: string;
    /**
     * 接続送電サービスメニューコード：英数字<br>　コード変換マスターテーブル.画面項目ID「C021060」のユーザコードを設定
     */
    transMenuCode?: string;
    /**
     * 接続送電サービスメニューコード名称：全半角混在
     */
    transMenuCodeAname?: string;
    /**
     * 電気主任技術者漢字氏名：全角
     */
    eleanKnjnm?: string;
    /**
     * 電気主任技術者所属：全角
     */
    eleanAttach?: string;
    /**
     * 電気主任技術者電話番号：半角
     */
    eleanTelno?: string;
    /**
     * 託送契約決定方法コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300060」のユーザコードを設定
     */
    cnsgmtCtrdcsCode?: string;
    /**
     * 託送契約決定方法コード名称：全半角混在
     */
    cnsgmtCtrdcsCodeAname?: string;
    /**
     * 力率
     */
    pwrPrcent?: number;
    /**
     * 需要者窓口氏名：全角
     */
    dmndrdName?: string;
    /**
     * 需要者窓口所属：全角
     */
    dmndrdAttach?: string;
    /**
     * 需要者窓口電話番号：半角
     */
    dmndrdTelno?: string;
    /**
     * 自家補契約電力
     */
    pgsupEpower?: number;
    /**
     * 自家補契約電力単位コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300100」のユーザコードを設定
     */
    pgsupEpowerUnitcd?: string;
    /**
     * 自家補契約電力単位コード名称：全半角混在
     */
    pgsupEpowerUnitcdAname?: string;
    /**
     * 予備線契約電力
     */
    splineEpower?: number;
    /**
     * 予備線契約電力単位コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300100」のユーザコードを設定
     */
    splineEpowerUnitcd?: string;
    /**
     * 予備線契約電力単位コード名称：全半角混在
     */
    splineEpowerUnitcdAname?: string;
    /**
     * 予備電源契約容量
     */
    stpersplCapa?: number;
    /**
     * 予備電源契約容量単位コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C300100」のユーザコードを設定
     */
    stpersplCapaUniticd?: string;
    /**
     * 予備電源契約容量単位コード名称：全半角混在
     */
    stpersplCapaUniticdAname?: string;
    /**
     * 約款別パターン：英数字<br>　コード変換マスターテーブル.画面項目ID「D400040」のユーザコードを設定
     */
    stiPtn?: string;
    /**
     * 約款別パターン名称：全半角混在
     */
    stiPtnAname?: string;
}

